import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isAuth: false,
    tokenpub: localStorage.getItem('tokenpub') || '',
    tokenscr: localStorage.getItem('tokenscr') || '',
    usernik: localStorage.getItem('usernik') || '',
    useremail: localStorage.getItem('useremail') || '',
    userrole: localStorage.getItem('userrole') || '',
    username: localStorage.getItem('username') || '',
    userfname: localStorage.getItem('userfname') || '',
    userlname: localStorage.getItem('userlname') || '',
    userjob: localStorage.getItem('userjob') || '[]',
    usersjob: localStorage.getItem('usersjob') || '[]',
    titlepage: localStorage.getItem('titlepage') || 'Practical Accounting Dictionary',
    k_favorite: [],
    k_history: [],
    isFavorite: false,
    wday: null,
  },
  mutations: {
    AUTH_SUCCESS(state, resp) {
      const fullname = resp.firstname + ' ' + resp.lastname;
      // set localStorage
      localStorage.setItem('tokenscr', resp.token);
      localStorage.setItem('usernik', resp.email);
      localStorage.setItem('useremail', resp.email);
      localStorage.setItem('userrole', resp.role);
      localStorage.setItem('username', fullname);
      localStorage.setItem('userfname', resp.firstname);
      localStorage.setItem('userlname', resp.lastname);
      localStorage.setItem('userjob', JSON.stringify(resp.job));
      localStorage.setItem('usersjob', JSON.stringify(resp.sjob));
      // set state
      state.tokenscr = resp.token;
      state.usernik = resp.email;
      state.useremail = resp.email;
      state.userrole = resp.role;
      state.username = fullname;
      state.userfname = resp.firstname;
      state.userlname = resp.lastname;
      state.userjob = JSON.stringify(resp.job);
      state.usersjob = JSON.stringify(resp.sjob);
      state.isAuth = true;
    },
    AUTH_LOGOUT(state) {
      // set localStorage
      localStorage.removeItem('tokenscr');
      localStorage.removeItem('usernik');
      localStorage.removeItem('useremail');
      localStorage.removeItem('userrole');
      localStorage.removeItem('username');
      localStorage.removeItem('userfname');
      localStorage.removeItem('userlname');
      localStorage.removeItem('userjob');
      localStorage.removeItem('usersjob');
      // set state
      state.tokenscr = '';
      state.usernik = '';
      state.useremail = '';
      state.userrole = '';
      state.username = '';
      state.userfname = '';
      state.userlname = '';
      state.userjob = '[]';
      state.usersjob = '[]';
      state.isAuth = false;
    },
    ADD_JOBAPP(state, jobid) {
      const newlist = JSON.parse(state.userjob);
      newlist.push(jobid);
      const newliststr = JSON.stringify(newlist);
      // set state
      state.userjob = newliststr;
      // set localStorage
      localStorage.removeItem('userjob');
      localStorage.setItem('userjob', newliststr);
    },
    ADD_JOBSAVE(state, jobid) {
      const newlist = JSON.parse(state.usersjob);
      newlist.push(jobid);
      const newliststr = JSON.stringify(newlist);
      // set state
      state.usersjob = newliststr;
      // set localStorage
      localStorage.removeItem('usersjob');
      localStorage.setItem('usersjob', newliststr);
    },
    REMOVE_JOBSAVE(state, jobid) {
      const newlist = JSON.parse(state.usersjob);
      const newlistr = Array();
      newlist.forEach((elm) => {
        if (elm.toString() !== jobid.toString()) {
          newlistr.push(elm);
        }
      });
      const newliststr = JSON.stringify(newlistr);
      // set state
      state.usersjob = newliststr;
      // set localStorage
      localStorage.removeItem('usersjob');
      localStorage.setItem('usersjob', newliststr);
    },
    UPDATE_TITLE(state, title) {
      // set state
      state.titlepage = title;
      // set localStorage
      localStorage.removeItem('titlepage');
      localStorage.setItem('titlepage', title);
    },
    ADD_FAV(state, payload) {
      let isEx = false;
      const idstr = 'id_vocab';
      for (const row of state.k_favorite) {
        if (row[idstr] === payload.id_vocab) {
          isEx = true;
        }
      }
      if (isEx === false) {
        state.k_favorite = state.k_favorite.concat(payload);
      }
    },
    DEL_FAV(state, payload) {
      let isEx = 0;
      const idstr = 'id_vocab';
      state.k_favorite.forEach((value, i) => {
        if (value[idstr] === payload.id_vocab) {
          isEx = i;
        }
      });
      state.k_favorite.splice(isEx, 1);
    },
    UPDATE_FAV(state, payload) {
      state.isFavorite = false;
      const idstr = 'id_vocab';
      for (const row of state.k_favorite) {
        if (row[idstr] === payload) {
          state.isFavorite = true;
        }
      }
    },
    RESET_FAV(state) {
      state.k_favorite = [];
    },
    ADD_HISTORY(state, payload) {
      let isEx = false;
      const idstr = 'id_vocab';
      for (const row of state.k_history) {
        if (row[idstr] === payload.id_vocab) {
          isEx = true;
        }
      }
      if (isEx === false) {
        state.k_history = state.k_history.concat(payload);
      }
    },
    RESET_HISTORY(state) {
      state.k_history = [];
    },
    UPDATE_WDAY(state, payload) {
      state.wday = payload;
    },
  },
  actions: {
  },
  getters: {
    isAuth: (state) => state.isAuth,
    tokenpub: (state) => state.tokenpub,
    tokenscr: (state) => state.tokenscr,
    usernik: (state) => state.usernik,
    useremail: (state) => state.useremail,
    userrole: (state) => state.userrole,
    username: (state) => state.username,
    userfname: (state) => state.userfname,
    userlname: (state) => state.userlname,
    userjob: (state) => state.userjob,
    usersjob: (state) => state.usersjob,
    titlepage: (state) => state.titlepage,
    isFavorite: (state) => state.isFavorite,
    wday: (state) => state.wday,
  },
  plugins: [createPersistedState()],
});
